var sony_TV_12D1 = {
    name: "TV_12D1",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,45,187,196],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,47,239,16],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,55,239,16],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,43,247,136],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,59,239,16],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,45,247,136],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,53,247,136],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,42,251,196],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,61,239,16],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,46,247,136],
        },
        {
            function: "CH",
            name: "CH",
            icon: "CH",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,43,123,196],
        },
        {
            function: "ENTER",
            name: "ENTER",
            icon: "ENTER",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,213,226],
        },
        {
            function: "KEY_ENTER",
            name: "KEY_ENTER",
            icon: "KEY_ENTER",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,43,123,196],
        },
        {
            function: "1-",
            name: "1-",
            icon: "1-",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,58,247,136],
        },
        {
            function: "2-",
            name: "2-",
            icon: "2-",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,45,123,196],
        },
        {
            function: "CH GUIDE",
            name: "CH GUIDE",
            icon: "CH GUIDE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,53,123,196],
        },
        {
            function: "GUIDE",
            name: "GUIDE",
            icon: "GUIDE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,53,123,196],
        },
        {
            function: "P/C",
            name: "P/C",
            icon: "P/C",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,53,123,196],
        },
        {
            function: "CLEAR",
            name: "CLEAR",
            icon: "CLEAR",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,42,189,226],
        },
        {
            function: "CHANNEL +",
            name: "CHANNEL +",
            icon: "CHANNEL +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,62,239,16],
        },
        {
            function: "CHANNEL_UP",
            name: "CHANNEL_UP",
            icon: "CHANNEL_UP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,62,239,16],
        },
        {
            function: "NEXT PAGE",
            name: "NEXT PAGE",
            icon: "NEXT PAGE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,62,239,16],
        },
        {
            function: "PROGR +",
            name: "PROGR +",
            icon: "PROGR +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,62,239,16],
        },
        {
            function: "CHANNEL -",
            name: "CHANNEL -",
            icon: "CHANNEL -",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,47,119,136],
        },
        {
            function: "CHANNEL_DOWN",
            name: "CHANNEL_DOWN",
            icon: "CHANNEL_DOWN",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,47,119,136],
        },
        {
            function: "PREV PAGE",
            name: "PREV PAGE",
            icon: "PREV PAGE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,47,119,136],
        },
        {
            function: "PROGR -",
            name: "PROGR -",
            icon: "PROGR -",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,47,119,136],
        },
        {
            function: "VOLUME +",
            name: "VOLUME +",
            icon: "VOLUME +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,55,119,136],
        },
        {
            function: "VOLUME_UP",
            name: "VOLUME_UP",
            icon: "VOLUME_UP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,55,119,136],
        },
        {
            function: "VOLUME -",
            name: "VOLUME -",
            icon: "VOLUME -",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,43,187,196],
        },
        {
            function: "VOLUME_DOWN",
            name: "VOLUME_DOWN",
            icon: "VOLUME_DOWN",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,43,187,196],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,59,119,136],
        },
        {
            function: "MUTING",
            name: "MUTING",
            icon: "MUTING",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,59,119,136],
        },
        {
            function: "POWER OFF",
            name: "POWER OFF",
            icon: "POWER OFF",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,62,218,162],
        },
        {
            function: "POWER ON/OFF",
            name: "POWER ON/OFF",
            icon: "POWER ON/OFF",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,45,187,196],
        },
        {
            function: "NORMALIZE PICT",
            name: "NORMALIZE PICT",
            icon: "NORMALIZE PICT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,53,187,196],
        },
        {
            function: "RECORD",
            name: "RECORD",
            icon: "RECORD",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,53,187,196],
        },
        {
            function: "RESET",
            name: "RESET",
            icon: "RESET",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,53,187,196],
        },
        {
            function: "MTS / SAP",
            name: "MTS / SAP",
            icon: "MTS / SAP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,42,221,226],
        },
        {
            function: "MTS/MPX",
            name: "MTS/MPX",
            icon: "MTS/MPX",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,42,221,226],
        },
        {
            function: "MTS/SAP",
            name: "MTS/SAP",
            icon: "MTS/SAP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,42,221,226],
        },
        {
            function: "CONTRAST +",
            name: "CONTRAST +",
            icon: "CONTRAST +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,61,119,136],
        },
        {
            function: "PICTURE +",
            name: "PICTURE +",
            icon: "PICTURE +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,61,119,136],
        },
        {
            function: "CONTRAST -",
            name: "CONTRAST -",
            icon: "CONTRAST -",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,46,187,196],
        },
        {
            function: "PICTURE -",
            name: "PICTURE -",
            icon: "PICTURE -",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,46,187,196],
        },
        {
            function: "COLOR +",
            name: "COLOR +",
            icon: "COLOR +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,54,187,196],
        },
        {
            function: "COLOR -",
            name: "COLOR -",
            icon: "COLOR -",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,43,93,226],
        },
        {
            function: "-/--",
            name: "-/--",
            icon: "-/--",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,93,226],
        },
        {
            function: "BRIGHT +",
            name: "BRIGHT +",
            icon: "BRIGHT +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,53,93,226],
        },
        {
            function: "BRIGHTNESS +",
            name: "BRIGHTNESS +",
            icon: "BRIGHTNESS +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,53,93,226],
        },
        {
            function: "BRIGHT -",
            name: "BRIGHT -",
            icon: "BRIGHT -",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,63,90,162],
        },
        {
            function: "BRIGHTNESS -",
            name: "BRIGHTNESS -",
            icon: "BRIGHTNESS -",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,63,90,162],
        },
        {
            function: "HUE -",
            name: "HUE -",
            icon: "HUE -",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,63,111,16],
        },
        {
            function: "HUE +",
            name: "HUE +",
            icon: "HUE +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,47,183,136],
        },
        {
            function: "SHARPNESS +",
            name: "SHARPNESS +",
            icon: "SHARPNESS +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,55,183,136],
        },
        {
            function: "SHARPNESS -",
            name: "SHARPNESS -",
            icon: "SHARPNESS -",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,43,219,196],
        },
        {
            function: "ANTENNA",
            name: "ANTENNA",
            icon: "ANTENNA",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,54,219,196],
        },
        {
            function: "INPUT TV",
            name: "INPUT TV",
            icon: "INPUT TV",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,59,183,136],
        },
        {
            function: "INPUT: TV TUNER",
            name: "INPUT: TV TUNER",
            icon: "INPUT: TV TUNER",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,59,183,136],
        },
        {
            function: "TUNER",
            name: "TUNER",
            icon: "TUNER",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,59,183,136],
        },
        {
            function: "TUNNER",
            name: "TUNNER",
            icon: "TUNNER",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,59,183,136],
        },
        {
            function: "AV CHANNEL",
            name: "AV CHANNEL",
            icon: "AV CHANNEL",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,45,219,196],
        },
        {
            function: "HALT",
            name: "HALT",
            icon: "HALT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,45,219,196],
        },
        {
            function: "INPUT",
            name: "INPUT",
            icon: "INPUT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,45,219,196],
        },
        {
            function: "INPUT SOURCE",
            name: "INPUT SOURCE",
            icon: "INPUT SOURCE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,45,219,196],
        },
        {
            function: "INPUT TOGGLE",
            name: "INPUT TOGGLE",
            icon: "INPUT TOGGLE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,45,219,196],
        },
        {
            function: "TV/VID",
            name: "TV/VID",
            icon: "TV/VID",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,45,219,196],
        },
        {
            function: "TV/VIDEO",
            name: "TV/VIDEO",
            icon: "TV/VIDEO",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,45,219,196],
        },
        {
            function: "VIDEO INPUT",
            name: "VIDEO INPUT",
            icon: "VIDEO INPUT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,45,219,196],
        },
        {
            function: "BALANCE -",
            name: "BALANCE -",
            icon: "BALANCE -",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,53,219,196],
        },
        {
            function: "BALANCE +",
            name: "BALANCE +",
            icon: "BALANCE +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,42,237,226],
        },
        {
            function: "LOUDNESS",
            name: "LOUDNESS",
            icon: "LOUDNESS",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,61,183,136],
        },
        {
            function: "OSE",
            name: "OSE",
            icon: "OSE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,61,183,136],
        },
        {
            function: "EFFECT",
            name: "EFFECT",
            icon: "EFFECT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,46,219,196],
        },
        {
            function: "SURROUND",
            name: "SURROUND",
            icon: "SURROUND",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,46,219,196],
        },
        {
            function: "ANT",
            name: "ANT",
            icon: "ANT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,54,219,196],
        },
        {
            function: "ANT/AUX",
            name: "ANT/AUX",
            icon: "ANT/AUX",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,54,219,196],
        },
        {
            function: "MAIN/AUX COAX TOGGLE",
            name: "MAIN/AUX COAX TOGGLE",
            icon: "MAIN/AUX COAX TOGGLE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,54,219,196],
        },
        {
            function: "TV",
            name: "TV",
            icon: "TV",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,54,219,196],
        },
        {
            function: "ON",
            name: "ON",
            icon: "ON",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,53,109,226],
        },
        {
            function: "POWER ON",
            name: "POWER ON",
            icon: "POWER ON",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,53,109,226],
        },
        {
            function: "PWR ON",
            name: "PWR ON",
            icon: "PWR ON",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,53,109,226],
        },
        {
            function: "STANDBY",
            name: "STANDBY",
            icon: "STANDBY",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,62,218,162],
        },
        {
            function: "CURSER RIGHT",
            name: "CURSER RIGHT",
            icon: "CURSER RIGHT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,43,173,226],
        },
        {
            function: "CURSOR RIGHT",
            name: "CURSOR RIGHT",
            icon: "CURSOR RIGHT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,43,173,226],
        },
        {
            function: "CURSOR RT",
            name: "CURSOR RT",
            icon: "CURSOR RT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,43,173,226],
        },
        {
            function: "JOYSTICK RIGHT",
            name: "JOYSTICK RIGHT",
            icon: "JOYSTICK RIGHT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,43,173,226],
        },
        {
            function: "KEYPAD RIGHT",
            name: "KEYPAD RIGHT",
            icon: "KEYPAD RIGHT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,43,173,226],
        },
        {
            function: "MENU RIGHT",
            name: "MENU RIGHT",
            icon: "MENU RIGHT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,43,173,226],
        },
        {
            function: "PIP SWAP RIGHT",
            name: "PIP SWAP RIGHT",
            icon: "PIP SWAP RIGHT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,43,173,226],
        },
        {
            function: "RIGHT",
            name: "RIGHT",
            icon: "RIGHT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,43,173,226],
        },
        {
            function: "CURSER LEFT",
            name: "CURSER LEFT",
            icon: "CURSER LEFT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,59,91,196],
        },
        {
            function: "CURSOR LEFT",
            name: "CURSOR LEFT",
            icon: "CURSOR LEFT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,59,91,196],
        },
        {
            function: "CURSOR LF",
            name: "CURSOR LF",
            icon: "CURSOR LF",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,59,91,196],
        },
        {
            function: "JOYSTICK LEFT",
            name: "JOYSTICK LEFT",
            icon: "JOYSTICK LEFT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,59,91,196],
        },
        {
            function: "KEYPAD LEFT",
            name: "KEYPAD LEFT",
            icon: "KEYPAD LEFT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,59,91,196],
        },
        {
            function: "LEFT",
            name: "LEFT",
            icon: "LEFT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,59,91,196],
        },
        {
            function: "MENU LEFT",
            name: "MENU LEFT",
            icon: "MENU LEFT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,59,91,196],
        },
        {
            function: "PIP SWAP LEFT",
            name: "PIP SWAP LEFT",
            icon: "PIP SWAP LEFT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,59,91,196],
        },
        {
            function: "PICTURE MODE",
            name: "PICTURE MODE",
            icon: "PICTURE MODE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,59,171,196],
        },
        {
            function: "SLEEP",
            name: "SLEEP",
            icon: "SLEEP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,53,173,226],
        },
        {
            function: "EUROPEAN TV ON",
            name: "EUROPEAN TV ON",
            icon: "EUROPEAN TV ON",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,61,91,196],
        },
        {
            function: "TELETEXT OFF",
            name: "TELETEXT OFF",
            icon: "TELETEXT OFF",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,61,91,196],
        },
        {
            function: "TEXT OFF",
            name: "TEXT OFF",
            icon: "TEXT OFF",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,61,91,196],
        },
        {
            function: "TV ON",
            name: "TV ON",
            icon: "TV ON",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,61,91,196],
        },
        {
            function: "DISPLAY",
            name: "DISPLAY",
            icon: "DISPLAY",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,192,93,63,181,68],
        },
        {
            function: "DSPL",
            name: "DSPL",
            icon: "DSPL",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,54,173,226],
        },
        {
            function: "INFO",
            name: "INFO",
            icon: "INFO",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,54,173,226],
        },
        {
            function: "CHANNEL PREVIOUS",
            name: "CHANNEL PREVIOUS",
            icon: "CHANNEL PREVIOUS",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,59,218,162],
        },
        {
            function: "JUMP",
            name: "JUMP",
            icon: "JUMP",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,59,218,162],
        },
        {
            function: "LAST CHANNEL",
            name: "LAST CHANNEL",
            icon: "LAST CHANNEL",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,59,218,162],
        },
        {
            function: "RETURN",
            name: "RETURN",
            icon: "RETURN",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,213,226],
        },
        {
            function: "SWAP CHANNEL",
            name: "SWAP CHANNEL",
            icon: "SWAP CHANNEL",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,59,218,162],
        },
        {
            function: "TELETEXT ON",
            name: "TELETEXT ON",
            icon: "TELETEXT ON",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,192,93,63,181,68],
        },
        {
            function: "TEXT",
            name: "TEXT",
            icon: "TEXT",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,192,93,63,181,68],
        },
        {
            function: "INPUT 1",
            name: "INPUT 1",
            icon: "INPUT 1",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,63,175,16],
        },
        {
            function: "INPUT-LINE",
            name: "INPUT-LINE",
            icon: "INPUT-LINE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,63,175,16],
        },
        {
            function: "INPUT: VIDEO 1",
            name: "INPUT: VIDEO 1",
            icon: "INPUT: VIDEO 1",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,63,175,16],
        },
        {
            function: "LINE",
            name: "LINE",
            icon: "LINE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,63,175,16],
        },
        {
            function: "VIDEO",
            name: "VIDEO",
            icon: "VIDEO",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,63,175,16],
        },
        {
            function: "VIDEO - 1",
            name: "VIDEO - 1",
            icon: "VIDEO - 1",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,63,175,16],
        },
        {
            function: "VIDEO 1",
            name: "VIDEO 1",
            icon: "VIDEO 1",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,63,175,16],
        },
        {
            function: "VIDEO1",
            name: "VIDEO1",
            icon: "VIDEO1",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,63,175,16],
        },
        {
            function: "INPUT 2",
            name: "INPUT 2",
            icon: "INPUT 2",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,47,215,136],
        },
        {
            function: "INPUT: VIDEO 2",
            name: "INPUT: VIDEO 2",
            icon: "INPUT: VIDEO 2",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,47,215,136],
        },
        {
            function: "OPTION",
            name: "OPTION",
            icon: "OPTION",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,47,215,136],
        },
        {
            function: "VIDEO - 2",
            name: "VIDEO - 2",
            icon: "VIDEO - 2",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,47,215,136],
        },
        {
            function: "VIDEO 2",
            name: "VIDEO 2",
            icon: "VIDEO 2",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,47,215,136],
        },
        {
            function: "INPUT 3",
            name: "INPUT 3",
            icon: "INPUT 3",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,55,215,136],
        },
        {
            function: "INPUT: VIDEO 3",
            name: "INPUT: VIDEO 3",
            icon: "INPUT: VIDEO 3",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,55,215,136],
        },
        {
            function: "VIDEO - 3",
            name: "VIDEO - 3",
            icon: "VIDEO - 3",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,55,215,136],
        },
        {
            function: "VIDEO 3",
            name: "VIDEO 3",
            icon: "VIDEO 3",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,55,215,136],
        },
        {
            function: "INPUT-RGB 1",
            name: "INPUT-RGB 1",
            icon: "INPUT-RGB 1",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,43,235,196],
        },
        {
            function: "INPUT-RGB1",
            name: "INPUT-RGB1",
            icon: "INPUT-RGB1",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,43,235,196],
        },
        {
            function: "INPUT1",
            name: "INPUT1",
            icon: "INPUT1",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,43,235,196],
        },
        {
            function: "RGB",
            name: "RGB",
            icon: "RGB",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,43,235,196],
        },
        {
            function: "RGB1",
            name: "RGB1",
            icon: "RGB1",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,43,235,196],
        },
        {
            function: "INPUT-RGB 2",
            name: "INPUT-RGB 2",
            icon: "INPUT-RGB 2",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,59,215,136],
        },
        {
            function: "INPUT-RGB2",
            name: "INPUT-RGB2",
            icon: "INPUT-RGB2",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,59,215,136],
        },
        {
            function: "INPUT2",
            name: "INPUT2",
            icon: "INPUT2",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,59,215,136],
        },
        {
            function: "RGB2",
            name: "RGB2",
            icon: "RGB2",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,59,215,136],
        },
        {
            function: "INPUT 4",
            name: "INPUT 4",
            icon: "INPUT 4",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,42,245,226],
        },
        {
            function: "INPUT: VIDEO 4",
            name: "INPUT: VIDEO 4",
            icon: "INPUT: VIDEO 4",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,42,245,226],
        },
        {
            function: "VIDEO - 4",
            name: "VIDEO - 4",
            icon: "VIDEO - 4",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,42,245,226],
        },
        {
            function: "VIDEO 4",
            name: "VIDEO 4",
            icon: "VIDEO 4",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,42,245,226],
        },
        {
            function: "INPUT 5",
            name: "INPUT 5",
            icon: "INPUT 5",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,61,215,136],
        },
        {
            function: "INPUT: VIDEO 5",
            name: "INPUT: VIDEO 5",
            icon: "INPUT: VIDEO 5",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,61,215,136],
        },
        {
            function: "VIDEO - 5",
            name: "VIDEO - 5",
            icon: "VIDEO - 5",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,61,215,136],
        },
        {
            function: "VIDEO 5",
            name: "VIDEO 5",
            icon: "VIDEO 5",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,61,215,136],
        },
        {
            function: "INPUT 6",
            name: "INPUT 6",
            icon: "INPUT 6",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,46,235,196],
        },
        {
            function: "INPUT: VIDEO 6",
            name: "INPUT: VIDEO 6",
            icon: "INPUT: VIDEO 6",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,46,235,196],
        },
        {
            function: "VIDEO - 6",
            name: "VIDEO - 6",
            icon: "VIDEO - 6",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,46,235,196],
        },
        {
            function: "VIDEO 6",
            name: "VIDEO 6",
            icon: "VIDEO 6",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,46,235,196],
        },
        {
            function: "VIDEO 7",
            name: "VIDEO 7",
            icon: "VIDEO 7",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,54,235,196],
        },
        {
            function: "VIDEO 8",
            name: "VIDEO 8",
            icon: "VIDEO 8",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,43,117,226],
        },
        {
            function: "VIDEO 9",
            name: "VIDEO 9",
            icon: "VIDEO 9",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,58,235,196],
        },
        {
            function: "INPUT-Y/C",
            name: "INPUT-Y/C",
            icon: "INPUT-Y/C",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,117,226],
        },
        {
            function: "S/VIDEO",
            name: "S/VIDEO",
            icon: "S/VIDEO",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,117,226],
        },
        {
            function: "VIDEO 10",
            name: "VIDEO 10",
            icon: "VIDEO 10",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,117,226],
        },
        {
            function: "Y/C",
            name: "Y/C",
            icon: "Y/C",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,117,226],
        },
        {
            function: "CABLE",
            name: "CABLE",
            icon: "CABLE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,53,117,226],
        },
        {
            function: "VIDEO 11",
            name: "VIDEO 11",
            icon: "VIDEO 11",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,53,117,226],
        },
        {
            function: "VIDEO 12",
            name: "VIDEO 12",
            icon: "VIDEO 12",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,62,186,162],
        },
        {
            function: "INTERNAL SPKS ON/OFF",
            name: "INTERNAL SPKS ON/OFF",
            icon: "INTERNAL SPKS ON/OFF",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,62,215,136],
        },
        {
            function: "SPEAKER",
            name: "SPEAKER",
            icon: "SPEAKER",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,62,215,136],
        },
        {
            function: "PIP CH +",
            name: "PIP CH +",
            icon: "PIP CH +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,61,107,196],
        },
        {
            function: "PIP CH+",
            name: "PIP CH+",
            icon: "PIP CH+",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,61,107,196],
        },
        {
            function: "PIP CHANNEL +",
            name: "PIP CHANNEL +",
            icon: "PIP CHANNEL +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,61,107,196],
        },
        {
            function: "PIP CH -",
            name: "PIP CH -",
            icon: "PIP CH -",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,46,181,226],
        },
        {
            function: "PIP CH-",
            name: "PIP CH-",
            icon: "PIP CH-",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,46,181,226],
        },
        {
            function: "PIP CHANNEL 1",
            name: "PIP CHANNEL 1",
            icon: "PIP CHANNEL 1",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,46,181,226],
        },
        {
            function: "PIP INPUT",
            name: "PIP INPUT",
            icon: "PIP INPUT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,54,181,226],
        },
        {
            function: "PIP TV/VIDEO",
            name: "PIP TV/VIDEO",
            icon: "PIP TV/VIDEO",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,54,181,226],
        },
        {
            function: "PAP",
            name: "PAP",
            icon: "PAP",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,59,186,162],
        },
        {
            function: "PIP",
            name: "PIP",
            icon: "PIP",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,59,186,162],
        },
        {
            function: "PIP ON",
            name: "PIP ON",
            icon: "PIP ON",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,59,186,162],
        },
        {
            function: "PIP ON/OFF",
            name: "PIP ON/OFF",
            icon: "PIP ON/OFF",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,59,186,162],
        },
        {
            function: "PIP ON/SIZE",
            name: "PIP ON/SIZE",
            icon: "PIP ON/SIZE",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,59,186,162],
        },
        {
            function: "PIP SIZE",
            name: "PIP SIZE",
            icon: "PIP SIZE",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,59,186,162],
        },
        {
            function: "FREEZE",
            name: "FREEZE",
            icon: "FREEZE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,58,181,226],
        },
        {
            function: "PICTURE FREEZE",
            name: "PICTURE FREEZE",
            icon: "PICTURE FREEZE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,58,181,226],
        },
        {
            function: "PIP FREEZE",
            name: "PIP FREEZE",
            icon: "PIP FREEZE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,58,181,226],
        },
        {
            function: "STILL",
            name: "STILL",
            icon: "STILL",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,58,181,226],
        },
        {
            function: "PIP LOCATION",
            name: "PIP LOCATION",
            icon: "PIP LOCATION",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,47,186,162],
        },
        {
            function: "PIP POSITION",
            name: "PIP POSITION",
            icon: "PIP POSITION",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,47,186,162],
        },
        {
            function: "POSITION",
            name: "POSITION",
            icon: "POSITION",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,47,186,162],
        },
        {
            function: "PAP SWAP",
            name: "PAP SWAP",
            icon: "PAP SWAP",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,192,93,63,117,68],
        },
        {
            function: "PIC SWAP",
            name: "PIC SWAP",
            icon: "PIC SWAP",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,192,93,63,117,68],
        },
        {
            function: "PIP SWAP",
            name: "PIP SWAP",
            icon: "PIP SWAP",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,192,93,63,117,68],
        },
        {
            function: "SWAP",
            name: "SWAP",
            icon: "SWAP",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,192,93,63,117,68],
        },
        {
            function: "MENU",
            name: "MENU",
            icon: "MENU",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,63,87,136],
        },
        {
            function: "EXIT",
            name: "EXIT",
            icon: "EXIT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,43,213,226],
        },
        {
            function: "PIC MODE",
            name: "PIC MODE",
            icon: "PIC MODE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,59,171,196],
        },
        {
            function: "PICTURE",
            name: "PICTURE",
            icon: "PICTURE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,59,171,196],
        },
        {
            function: "VIDEO PROFILE",
            name: "VIDEO PROFILE",
            icon: "VIDEO PROFILE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,59,171,196],
        },
        {
            function: "CURSOR CLICK",
            name: "CURSOR CLICK",
            icon: "CURSOR CLICK",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,213,226],
        },
        {
            function: "CURSOR ENTER",
            name: "CURSOR ENTER",
            icon: "CURSOR ENTER",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,213,226],
        },
        {
            function: "CURSOR SELECT",
            name: "CURSOR SELECT",
            icon: "CURSOR SELECT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,213,226],
        },
        {
            function: "KEYPAD OK",
            name: "KEYPAD OK",
            icon: "KEYPAD OK",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,213,226],
        },
        {
            function: "MENU OK",
            name: "MENU OK",
            icon: "MENU OK",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,213,226],
        },
        {
            function: "OK",
            name: "OK",
            icon: "OK",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,213,226],
        },
        {
            function: "RETURN-CENTERBUTTON",
            name: "RETURN-CENTERBUTTON",
            icon: "RETURN-CENTERBUTTON",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,213,226],
        },
        {
            function: "SELECT",
            name: "SELECT",
            icon: "SELECT",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,45,213,226],
        },
        {
            function: "PIP - SELECT RIGHT",
            name: "PIP - SELECT RIGHT",
            icon: "PIP - SELECT RIGHT",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,61,122,162],
        },
        {
            function: "UP (SELECT)",
            name: "UP (SELECT)",
            icon: "UP (SELECT)",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,61,122,162],
        },
        {
            function: "TV SYS",
            name: "TV SYS",
            icon: "TV SYS",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,61,171,196],
        },
        {
            function: "COLOUR SYS",
            name: "COLOUR SYS",
            icon: "COLOUR SYS",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,54,213,226],
        },
        {
            function: "AUTO PROGRAM",
            name: "AUTO PROGRAM",
            icon: "AUTO PROGRAM",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,59,122,162],
        },
        {
            function: "PRESET",
            name: "PRESET",
            icon: "PRESET",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,58,213,226],
        },
        {
            function: "SEARCH +",
            name: "SEARCH +",
            icon: "SEARCH +",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,47,122,162],
        },
        {
            function: "SEARCH -",
            name: "SEARCH -",
            icon: "SEARCH -",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,192,93,62,245,68],
        },
        {
            function: "TREBLE +",
            name: "TREBLE +",
            icon: "TREBLE +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,62,171,196],
        },
        {
            function: "TREBLE -",
            name: "TREBLE -",
            icon: "TREBLE -",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,47,85,226],
        },
        {
            function: "BASS +",
            name: "BASS +",
            icon: "BASS +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,55,85,226],
        },
        {
            function: "BASS -",
            name: "BASS -",
            icon: "BASS -",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,58,250,162],
        },
        {
            function: "+",
            name: "+",
            icon: "+",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,59,85,226],
        },
        {
            function: "CURSER UP",
            name: "CURSER UP",
            icon: "CURSER UP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,59,85,226],
        },
        {
            function: "CURSOR UP",
            name: "CURSOR UP",
            icon: "CURSOR UP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,59,85,226],
        },
        {
            function: "JOYSTICK UP",
            name: "JOYSTICK UP",
            icon: "JOYSTICK UP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,59,85,226],
        },
        {
            function: "KEYPAD UP",
            name: "KEYPAD UP",
            icon: "KEYPAD UP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,59,85,226],
        },
        {
            function: "MENU +",
            name: "MENU +",
            icon: "MENU +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,59,85,226],
        },
        {
            function: "MENU UP",
            name: "MENU UP",
            icon: "MENU UP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,59,85,226],
        },
        {
            function: "PIP SIZE UP",
            name: "PIP SIZE UP",
            icon: "PIP SIZE UP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,59,85,226],
        },
        {
            function: "SELECT +",
            name: "SELECT +",
            icon: "SELECT +",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,59,85,226],
        },
        {
            function: "SELECT UP",
            name: "SELECT UP",
            icon: "SELECT UP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,59,85,226],
        },
        {
            function: "UP",
            name: "UP",
            icon: "UP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,59,85,226],
        },
        {
            function: "-",
            name: "-",
            icon: "-",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,54,250,162],
        },
        {
            function: "CURSER DOWN",
            name: "CURSER DOWN",
            icon: "CURSER DOWN",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,54,250,162],
        },
        {
            function: "CURSOR DN",
            name: "CURSOR DN",
            icon: "CURSOR DN",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,54,250,162],
        },
        {
            function: "CURSOR DOWN",
            name: "CURSOR DOWN",
            icon: "CURSOR DOWN",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,54,250,162],
        },
        {
            function: "CURSOR DWN",
            name: "CURSOR DWN",
            icon: "CURSOR DWN",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,54,250,162],
        },
        {
            function: "DOWN",
            name: "DOWN",
            icon: "DOWN",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,54,250,162],
        },
        {
            function: "JOYSTICK DOWN",
            name: "JOYSTICK DOWN",
            icon: "JOYSTICK DOWN",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,54,250,162],
        },
        {
            function: "KEYPAD DOWN",
            name: "KEYPAD DOWN",
            icon: "KEYPAD DOWN",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,54,250,162],
        },
        {
            function: "MENU -",
            name: "MENU -",
            icon: "MENU -",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,54,250,162],
        },
        {
            function: "MENU DOWN",
            name: "MENU DOWN",
            icon: "MENU DOWN",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,54,250,162],
        },
        {
            function: "PIP SIZE DOWN",
            name: "PIP SIZE DOWN",
            icon: "PIP SIZE DOWN",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,54,250,162],
        },
        {
            function: "SELECT DOWN",
            name: "SELECT DOWN",
            icon: "SELECT DOWN",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,54,250,162],
        },
        {
            function: "SELECT-",
            name: "SELECT-",
            icon: "SELECT-",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,54,250,162],
        },
        {
            function: "CHANNEL ADD",
            name: "CHANNEL ADD",
            icon: "CHANNEL ADD",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,112,98,61,85,226],
        },
        {
            function: "CHANNEL SKIP",
            name: "CHANNEL SKIP",
            icon: "CHANNEL SKIP",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,53,250,162],
        },
        {
            function: "PARAMETER SELECT",
            name: "PARAMETER SELECT",
            icon: "PARAMETER SELECT",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,24,96,43,250,162],
        },
        {
            function: "TRINITRON",
            name: "TRINITRON",
            icon: "TRINITRON",
            command: [26,0,4,176,4,88,2,88,2,88,2,96,9,88,2,88,2,192,93,55,245,68],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [26,0,4,88,2,88,2,96,9,88,2,176,4,88,2,88,2,208,107,127,158,32],
        },
        {
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,45,219,196],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,43,123,196],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,55,119,136],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,32,103,47,119,136],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,120,105,62,239,16],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [26,0,4,88,2,88,2,176,4,88,2,96,9,88,2,88,2,200,100,43,187,196],
        },
    ]
}
export default sony_TV_12D1